import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export type PortalEmptyPrimary =
  | { kind: 'link'; to: string; label: string }
  | { kind: 'button'; onClick: () => void; label: string };

const defaultPrimaryClass =
  'inline-flex items-center justify-center rounded-lg bg-orange-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-orange-700';

export interface PortalEmptyStateProps {
  icon: ReactNode;
  title: string;
  description: ReactNode;
  primaryAction?: PortalEmptyPrimary;
  primaryClassName?: string;
}

export default function PortalEmptyState({
  icon,
  title,
  description,
  primaryAction,
  primaryClassName = defaultPrimaryClass,
}: PortalEmptyStateProps) {
  return (
    <div className="mx-auto max-w-[400px] px-4 pt-[60px] pb-8 text-center">
      <div className="mb-4 text-[48px] leading-none" aria-hidden>
        {icon}
      </div>
      <h2 className="text-[18px] font-bold text-[#111827]">{title}</h2>
      <div className="mb-6 mt-2 text-sm leading-relaxed text-[#6b7280]">{description}</div>
      {primaryAction ? (
        primaryAction.kind === 'link' ? (
          <Link to={primaryAction.to} className={primaryClassName}>
            {primaryAction.label}
          </Link>
        ) : (
          <button type="button" onClick={primaryAction.onClick} className={primaryClassName}>
            {primaryAction.label}
          </button>
        )
      ) : null}
    </div>
  );
}
